// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var VirtualIbansPayoutsController = function ($scope, $http, gettext, PUtill) {

    function init() {
        $http.get('/api/v1/virtualIbansPayouts', {}).then(function (result) {
            $scope.payouts = result.data;
        });
    }

    init();
    
    $scope.translatePayoutStatus = function (payoutStatus){
        return PUtill.getText(payoutStatus);
    }
    
    gettext("Booked");
    gettext("Rejected");
    gettext("Pending");
    gettext("Canceled");
    gettext("Released");
    gettext("Upcoming");
}
VirtualIbansPayoutsController.$inject = ['$scope', '$http', 'gettext', 'PUtill'];
